import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';


const Setting = () => {
	const location = useLocation();
	const [activeItem, setActiveItem] = useState(location.pathname);

	const handleItemClick = (url) => {
		setActiveItem(url);
	};

	return (
		<>
			<Header />
			<BoxWrapper>
				<div  >
					<div className="container" >
						<h1 className="page_main_heading">Settings</h1>

						<div className="setting_page" >
							<div className="setting_menu_section" style={{ position: "sticky", top: "140px" }}>
								<div className="menu_section">
									<ul>
										<li className={activeItem === "/settings" ? "active" : ""}>
											<Link to="/settings" onClick={() => handleItemClick("/settings")}>

												<p>Countries</p>
											</Link>
										</li>

										<li className={activeItem === "/settings/operator" ? "active" : ""}>
											<Link to="/settings/operator" onClick={() => handleItemClick("/settings/operator")}>

												<p>Operator</p>
											</Link>
										</li>

										<li className={activeItem === "/settings/status" ? "active" : ""}>
											<Link to="/settings/status" onClick={() => handleItemClick("/settings/status")}>

												<p>Message Status</p>
											</Link>
										</li>


										<li className={activeItem === "/settings/sdk-url" ? "active" : ""}>
											<Link to="/settings/sdk-url" onClick={() => handleItemClick("/settings/sdk-url")}>

												<p>SDK URL</p>
											</Link>
										</li>

										{/* <li className={activeItem === "/settings/sender" ? "active" : ""}>
										<Link to="/settings/sender" onClick={() => handleItemClick("/settings/sender")}>

											<p>Sender ID</p>
										</Link>
									</li> */}

										<li className={activeItem === "/settings/channel" ? "active" : ""}>
											<Link to="/settings/channel" onClick={() => handleItemClick("/settings/channel")}>

												<p>Channels</p>
											</Link>
										</li>


										<li className={activeItem === "/settings/routing-method" ? "active" : ""}>
											<Link to="/settings/routing-method/1" onClick={() => handleItemClick("/settings/routing-method")}>

												<p>Routing Method</p>
											</Link>
										</li>

										{/* <li className={activeItem === "/settings/variables" ? "active" : ""}>
										<Link to="/settings/variables" onClick={() => handleItemClick("/settings/variables")}>

											<p>Variables</p>
										</Link>
									</li> */}

										<li className={activeItem === "/settings/message-type" ? "active" : ""}>
											<Link to="/settings/message-type" onClick={() => handleItemClick("/settings/message-type")}>

												<p>Message Type</p>
											</Link>
										</li>

										{/* <li className={activeItem === "/settings/message-template-type" ? "active" : ""}>
										<Link to="/settings/message-template-type" onClick={() => handleItemClick("/settings/message-template-type")}>

											<p>Message Template Type</p>
										</Link>
									</li>

									<li className={activeItem === "/settings/template-message" ? "active" : ""}>
										<Link to="/settings/template-message" onClick={() => handleItemClick("/settings/template-message")}>

											<p>Template Messages</p>
										</Link>
									</li> */}
										<li className={activeItem === "/settings/categories" ? "active" : ""}>
											<Link to="/settings/categories" onClick={() => handleItemClick("/settings/categories")}>

												<p>Categories</p>
											</Link>
										</li>
										<li className={activeItem === "/settings/currency" ? "active" : ""}>
											<Link to="/settings/currency" onClick={() => handleItemClick("/settings/currency")}>

												<p>Currency</p>
											</Link>
										</li>








										<li className={activeItem === "/settings/user" ? "active" : ""}>
											<Link to="/settings/user" onClick={() => handleItemClick("/settings/user")}>

												<p>Users</p>
											</Link>
										</li>
										<li className={activeItem === "/settings/pages" ? "active" : ""}>
											<Link to="/settings/pages" onClick={() => handleItemClick("/settings/pages")}>

												<p>Pages</p>
											</Link>
										</li>
										<li className={activeItem === "/settings/redis-sync" ? "active" : ""}>
											<Link to="/settings/redis-sync" onClick={() => handleItemClick("/settings/redis-sync")}>

												<p>Sync</p>
											</Link>
										</li>


									</ul>
								</div>
							</div>

							<Outlet />
						</div>
					</div>

				</div>
			</BoxWrapper>

		</>
	);
}

export default Setting;